import React from 'react';
import { useLang } from '@/lib/LangContext';
import { CheckCircle2 } from 'lucide-react';

const FEEDER_IMG = 'https://customer-assets-cm19k8pv.emergentagent.net/job_auto-pet-feeder-1/artifacts/66123f424dbc3176_image.png';

/**
 * SmartPaw Feeder spotlight. The old "Book a consultation" CTA has been
 * removed per the latest amendment — the whole site now funnels users to the
 * single Register / Book a Consultation pair in the header + hero.
 */
export default function FeederSpotlight() {
  const { t } = useLang();
  const f = t.feeder || {};

  return (
    <section id="feeder" data-testid="feeder-spotlight" className="py-12 md:py-20">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative aspect-[4/3] max-h-[480px] rounded-[2rem] overflow-hidden bg-[#F5F2EB] card-soft mx-auto">
              <img
                src={FEEDER_IMG}
                alt="SmartPaw automatic smart feeder with a dog and a kitten"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-[2rem] bg-[#F25C05]/15 -z-10" aria-hidden />
            <div className="absolute -top-4 -left-4 w-20 h-20 rounded-[2rem] bg-[#0A4D8C]/15 -z-10" aria-hidden />
          </div>

          <div className="order-1 lg:order-2">
            {f.eyebrow && (
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-[#F25C05]/30 text-[11px] font-bold uppercase tracking-wider text-[#F25C05] mb-4">
                <span className="w-1.5 h-1.5 rounded-full bg-[#F25C05]" />
                {f.eyebrow}
              </div>
            )}
            <h2 className="font-display font-extrabold text-[#05223D] text-2xl md:text-3xl lg:text-4xl tracking-[-0.02em] leading-[1.15]">
              {f.title}
            </h2>
            <p className="mt-4 text-[#334155] leading-relaxed md:text-lg">
              {f.lead}
            </p>

            <ul className="mt-5 space-y-2.5">
              {[f.bullet1, f.bullet2, f.bullet3, f.bullet4].filter(Boolean).map((b, i) => (
                <li key={i} className="flex items-start gap-2.5 text-[#05223D]">
                  <CheckCircle2 className="w-5 h-5 shrink-0 text-[#0f6e44] mt-0.5" />
                  <span className="text-sm md:text-base">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
